<template>
    <div :data-interface-section="categoryId">
        <ShelfTitle
            :title="props.title"
            :link="props.link"
            :categoryId="props.categoryId"
        />
        <TrendingNow
            v-if="props.categoryId === 'trending_now'"
            :games="props.games"
            :eagerThumbs="props.eagerThumbs"
            :gameLinkTarget="props.gameLinkTarget"
            :preloadFirstCard="props.preloadFirstCard"
            :link="props.link"
            :categoryName="props.title"
            :ctrSlateId="props.ctrSlateId"
        />
        <NewGamesShelf
            v-else-if="props.categoryId === 'new'"
            :games="props.games"
            :eagerThumbs="props.eagerThumbs"
            :gameLinkTarget="props.gameLinkTarget"
            :preloadFirstCard="props.preloadFirstCard"
            :link="props.link"
            :categoryName="props.title"
        />
        <TopPlaygama
            v-else-if="props.categoryId === 'top_playgama'"
            :gameLinkTarget="props.gameLinkTarget"
            :games="props.games"
        />
        <GeneralShelf
            v-else
            :games="props.games"
            :eagerThumbs="props.eagerThumbs"
            :gameLinkTarget="props.gameLinkTarget"
            :preloadFirstCard="props.preloadFirstCard"
            :link="props.link"
            :categoryName="props.title"
        />
    </div>
</template>
<script lang="ts" setup>
import type { RouteLocationNamedRaw } from 'vue-router'

import GeneralShelf from '@/components/GamesShelf/GeneralShelf.vue'
import NewGamesShelf from '@/components/GamesShelf/NewGamesShelf.vue'
import ShelfTitle from '@/components/GamesShelf/ShelfTitle.vue'
import type { LinkTarget, MainCategoriesType, ShortGameType } from '@/types'

import TopPlaygama from './TopPlaygama/TopPlaygama.vue'
import TrendingNow from './TrendingNow.vue'

const props = defineProps<{
    title: string
    categoryId: MainCategoriesType
    link?: RouteLocationNamedRaw
    gameLinkTarget: LinkTarget | undefined
    games: ShortGameType[] | undefined[]
    eagerThumbs?: number
    preloadFirstCard?: boolean
    ctrSlateId?: string
}>()
</script>
